import api from 'lib/trpcClient';

export default function useCarriedInterestFeeTemplateOptions(
  vehicleId: string,
) {
  const [carriedInterestFeeTemplates] =
    api.vehicle.listCarriedInterestFeeTemplates.useSuspenseQuery(
      {
        vehicleId,
      },
      {
        refetchOnWindowFocus: 'always',
      },
    );

  return [
    { value: 'none', label: 'None' },
    ...carriedInterestFeeTemplates.map((template) => ({
      value: template.id,
      label: template.name,
    })),
  ];
}
